module.exports = __webpack_public_path__ + "statics/img/default.9c04083b.png";